export default "__VITE_ASSET__C5QXSy7f__"